export default __webpack_public_path__ + "static/media/onboarding-step-3.d3e43df4.png";